var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceSuggestsReplacementPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.33331C13.9829 4.02029 13.3849 2.92815 12.3726 2.0569C11.3603 1.18563 10.1806 0.75 8.83335 0.75C7.85365 0.75 7.01951 0.961015 6.33094 1.38304C5.64237 1.80506 5.08762 2.26819 4.66669 2.77246V0.75H3.41671V5.33331H8.00002V4.08333H5.27565C5.61431 3.53526 6.08092 3.05102 6.67548 2.6306C7.27004 2.21019 7.98933 1.99998 8.83335 1.99998C9.83335 1.99998 10.7153 2.31595 11.4792 2.9479C12.2431 3.57984 12.7222 4.37498 12.9167 5.33331H14.1667ZM1.66669 14.2275L5.4776 10.4166C5.96158 10.8023 6.48534 11.0932 7.0489 11.2892C7.61247 11.4853 8.20729 11.5833 8.83335 11.5833C9.6528 11.5833 10.4322 11.4043 11.1715 11.0464C11.9108 10.6885 12.5203 10.1933 13 9.56083V11.5833H14.25V6.99998H9.66669V8.24996H12.3911C12.0364 8.86214 11.5484 9.36241 10.9271 9.75077C10.3059 10.1391 9.60794 10.3333 8.83335 10.3333C7.83335 10.3333 6.95141 10.0173 6.18752 9.3854C5.42363 8.75345 4.94447 7.95831 4.75002 6.99998H3.50004C3.56949 7.49998 3.69449 7.95003 3.87504 8.35013C4.0556 8.75024 4.29706 9.14634 4.59942 9.53844L0.788502 13.3493L1.66669 14.2275Z",
    fill: "#4A148C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceSuggestsReplacementPink);
export default __webpack_public_path__ + "static/media/resource-suggests-replacement-pink.ae471616.svg";
export { ForwardRef as ReactComponent };